var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheLeak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8437 51.3787H46.5929V9H42.8437V51.3787ZM50.2508 24.0015V37.3132H54V24.0015H50.2508ZM35.4366 46.6934H39.1857V13.6901H35.4366V46.6934ZM28.0294 36.3819H31.7786V24.0063H28.0294V36.3819ZM20.7183 51.3834H24.4674V9.00481H20.7183V51.3834ZM13.4071 43.8851H17.1563V16.508H13.4071V43.8851ZM6 24.0063H9.74917V36.3819H6V24.0063Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheLeak);
export default __webpack_public_path__ + "static/media/theLeak.17df34a9.svg";
export { ForwardRef as ReactComponent };